import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import ProductOption from './ProductOption'

// Local replacement for react-storefront/option/ProductOptionSelector.
// Renders a set of selectable product options (text or swatch) as buttons.
const useStyles = makeStyles(
  theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    button: {
      margin: theme.spacing(0, 0.5, 0.5, 0),
    },
  }),
  { name: 'RSFProductOptionSelector' },
)

export default function ProductOptionSelector({
  options,
  name,
  classes,
  optionProps = {},
  skeleton,
  value,
  onChange,
  variant,
  strikeThroughDisabled = false,
  OptionComponent = ProductOption,
}) {
  classes = useStyles({ classes })

  if (skeleton) {
    options = new Array(skeleton).fill(0).map((_item, i) => ({ id: i, text: '' }))
  }

  if (!options) return null

  return (
    <div data-id="ProductOptionSelector" className={classes.root}>
      {options.map((option, i) => (
        <OptionComponent
          selectedOption={value}
          onSelectedOptionChange={onChange}
          {...optionProps}
          variant={variant || (option.image || option.color ? 'swatch' : 'text')}
          name={name}
          key={option.id}
          className={clsx(classes.button, optionProps.className)}
          index={i}
          color={option.color}
          imageProps={option.image}
          value={option}
          skeleton={skeleton != null}
          strikeThroughDisabled={strikeThroughDisabled}
        />
      ))}
    </div>
  )
}
